import { axiosClient } from '../../../shared/api';

export const listFeedback = async (query = '') => {
  const response = await axiosClient.get(`/feedback${query}`);
  return response.data;
};

export const createFeedback = async (feedbackData) => {
  const response = await axiosClient.post('/feedback', feedbackData);
  return response.data;
};

export const updateFeedback = async (feedbackId, updatedData) => {
  const response = await axiosClient.put(`/feedback/${feedbackId}`, updatedData);
  return response.data;
};

export const getFeedbackStats = async () => {
  const response = await axiosClient.get('/feedback/stats');
  return response.data;
};
